import { Head } from "@inertiajs/react"

import { RoleForm } from "@/components/admin/role-form"
import AppLayout from "@/layouts/app-layout"
import { adminRolesPath } from "@/routes"
import type { BreadcrumbItem, PermissionCatalog } from "@/types"

interface Props {
  role: {
    id: number
    name: string
    description: string | null
    system: boolean
    permissions: string[]
  }
  available_permissions: PermissionCatalog
}

export default function Edit({ role, available_permissions }: Props) {
  const breadcrumbs: BreadcrumbItem[] = [
    { title: "Roles", href: adminRolesPath() },
    { title: role.name, href: `/admin/roles/${role.id}/edit` },
  ]

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title={`Edit ${role.name}`} />

      <div className="max-w-4xl space-y-6 p-6">
        <div>
          <h1 className="text-2xl font-semibold capitalize">{role.name}</h1>
          <p className="text-muted-foreground text-sm">
            Changes take effect immediately for everyone holding this role.
          </p>
        </div>

        <RoleForm
          action={`/admin/roles/${role.id}`}
          method="patch"
          availablePermissions={available_permissions}
          role={role}
          submitLabel="Save Changes"
        />
      </div>
    </AppLayout>
  )
}
